import firebase from 'firebase/compat/app';
import 'firebase/compat/database';

const config = {
    //API KEYS
    apiKey: "AIzaSyCYjIUKf-pxUKysiMRWKTIvFcgpWLlz3ZQ",
    authDomain: "fir-vuechat-aaa42.firebaseapp.com",
    projectId: "fir-vuechat-aaa42",
    storageBucket: "fir-vuechat-aaa42.appspot.com",
    messagingSenderId: "360028272827",
    appId: "1:360028272827:web:8736a5183681520e3f119e"
}

const firebaseApp = firebase.initializeApp(config);

export default firebaseApp;
